package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_01_26_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-01-26")
@Composable
public fun Log_2024_01_26(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Vision of Entor",
        ogTitle = "Vision of Entor",
        date = LocalDate(2_024, 1, 26),
        ogDescription = "On the road to Zedj, the heroes defeat disguised Slaad and receive a divine vision of two items needed for the shield.",
        ogImage = "ai/2024-01-26.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-40", dateString = "Newgrowth 40")
        Log_2024_01_26_Day_1()
    }
}
